import script from "./HeaderGreenApiToggler.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderGreenApiToggler.vue?vue&type=script&setup=true&lang=js"

import "./HeaderGreenApiToggler.vue?vue&type=style&index=0&id=beb8f7c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beb8f7c4"]])

export default __exports__